import { ButtonBase } from ".";
import { ACTION_STATUS } from "..";

export class ProcessButtonModel extends ButtonBase {
    label: string = 'Process';
    action: string = ACTION_STATUS.process;
    matIconName: string = 'video_settings';
    colorClass: string = 'color-tertiary-500';
}